import router from './index'
import store from '../store'
import { PAGE_NAME } from '@/utils/constant'

const allowList = [PAGE_NAME.Login, PAGE_NAME.Exception, PAGE_NAME.StartApp, PAGE_NAME.SigninToCode]

router.beforeEach((to, from, next) => {
  const toRouteName = to.name
  if (store.getters.isLogin && store.getters.isLoginState) {
    if (toRouteName === PAGE_NAME.Login || toRouteName === PAGE_NAME.SigninToCode) {
      next({ name: PAGE_NAME.Home })
    } else if (+to.query.logout === 1) { // logout === 1 判断为退出登录
      store.dispatch('doLogout')
      next({ name: PAGE_NAME.Login })
    } else {
      next()
    }
  } else {
    if (allowList.includes(toRouteName)) {
      // 在免登录名单，直接进入
      next()
    } else {
      next({ name: PAGE_NAME.Login, query: { redirect: to.fullPath } })
    }
  }
})
